export default class Message {
  constructor(nom, prenom, email, tel, sujet, message) {
    this.nom = nom;
    this.prenom = prenom;
    this.email = email;
    this.tel = tel;
    this.sujet = sujet;
    this.message = message;
  }
}
